<template>
  <div class="field" @scroll="scrollHander($event)">
    <div class="back" @click="$router.push('/home')"><i></i></div>
    <div class="clubHead">
      <img
        src="https://archforce-website.oss-cn-hangzhou.aliyuncs.com/info/ResearchReport/header.png"
        alt=""
      />
      <h3>研究所</h3>
      <p>
        华锐金融科技研究所聚焦金融科技、监管科技、政策法规、合规风控、行业发展趋势等领域，以打造“行业智库”为目标，以赋能证券基金期货行业为宗旨，向行业提供各类咨询、研究及培训等服务。
      </p>
    </div>
    <div class="fieldContent">
      <div class="fieldTab">
        <div
          class="tabItem"
          :class="{ active: tabType == tab.type }"
          v-for="tab in tabData"
          :key="tab.type"
          @click="tabType = tab.type"
        >
          <p>{{ tab.name }}</p>
          <i class="tabBorder"></i>
        </div>
      </div>

      <div class="reportList">
        <div
          class="reportItem"
          v-for="item in reportData"
          :key="item.id"
          @click="goContent(item.id)"
        >
          <div class="itemLeft">
            <h4>{{ item.title }}</h4>
            <p>{{ formatDate(item.releaseTime) }}</p>
          </div>
          <div class="itemRight">
            <img :src="item.imgUrl" alt="" />
          </div>
        </div>
      </div>

      <div class="noData" v-if="noDataState">
        <div class="commonLine"></div>
        <div class="text">已经到底了</div>
        <div class="commonLine"></div>
      </div>
      <div class="loading" v-if="loading">加载中..</div>
    </div>
  </div>
</template>

<script>
import { researchReport } from '@/api'
export default {
  name: 'Field',
  data() {
    return {
      tabData: [
        {
          name: '推荐',
          type: 1,
        },
        {
          name: '动态观察',
          type: 2,
        },
        {
          name: '业务前瞻',
          type: 3,
        },
        {
          name: '风险预警',
          type: 4,
        },
        {
          name: '专题报告',
          type: 5,
        },
      ],
      tabType: this.$store.state.fieldState,
      currentPage: 1,
      reportData: [],
      loading: false,
      noDataState: false,
    }
  },
  mounted() {
    this.getReportData(true)
  },
  methods: {
    goContent(id) {
      this.$router.push({
        path: '/content/' + id,
        query: {
          type: 1,
        },
      })
    },
    scrollHander(eTarget) {
      if (this.noDataState) return
      if (this.loading) return
      let { srcElement: target } = eTarget
      const { scrollTop, offsetHeight, scrollHeight } = target
      if (scrollTop + offsetHeight >= scrollHeight) {
        this.loading = true
        this.getReportData(false)
      }
    },
    async getReportData(flag = false) {
      const data = await researchReport({
        currentPage: flag ? this.currentPage : ++this.currentPage,
        pageSize: 10,
        type: this.tabType,
      }).finally(() => (this.loading = false))
      if (flag) {
        this.reportData = data.list
      } else {
        this.reportData = [...this.reportData, ...data.list]
      }
      this.noDataState = this.reportData.length >= data.count
    },
  },
  watch: {
    tabType(newd) {
      this.currentPage = 1
      this.$store.commit('changeFieldState', newd)
      this.getReportData(true)
    },
  },
}
</script>

<style lang="scss" scoped>
.field {
  height: 100vh;
  background-color: #f5f6f8;
  overflow-y: auto;
  box-sizing: border-box;
  padding-bottom: 30px;
  .clubHead {
    position: relative;
    img {
      width: 100%;
      height: 216px;
    }
    h3 {
      position: absolute;
      top: 18px;
      left: 50%;
      margin-left: -27px;
      font-size: 18px;
      color: #ffffff;
    }
    p {
      position: absolute;
      left: 17px;
      right: 17px;
      bottom: 16px;
      font-size: 12px;
      font-weight: 400;
      color: #ffffff;
      line-height: 18px;
      letter-spacing: 1px;
    }
  }
  .fieldContent {
    margin-top: 15px;
  }
  .fieldTab {
    display: flex;
    justify-content: space-evenly;
    background: white;
    font-size: 14px;
    border-bottom: 1px solid #e5e5e5;
    .tabItem {
      position: relative;
      padding: 17px 0;
      .tabBorder {
        position: absolute;
        left: 50%;
        bottom: 0;
        display: none;
        width: 28px;
        height: 3px;
        margin-left: -14px;
        background: #4c8bff;
        border-radius: 3px;
      }
      &.active {
        color: #4c8bff;
        .tabBorder {
          display: block;
        }
      }
    }
  }
  .reportList {
    padding: 0;
    .reportItem {
      padding: 16px 17px;
      background: white;
      margin-top: 0;
      margin-bottom: 8px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .noData {
    width: calc(100% - 96px);
    display: flex;
    align-items: center;
    margin: 25px auto 0px auto;
    padding-bottom: 25px;
    font-size: 12px;
    font-weight: 400;
    color: #999ca1;
    .commonLine {
      width: calc(100% - 190px);
      height: 1px;
      background: #e5e5e5;
    }
    .text {
      margin: 0 15px;
    }
  }
  .loading {
    margin: 25px 0 0 0;
    padding-bottom: 25px;
    font-size: 12px;
    font-weight: 400;
    color: #999ca1;
    text-align: center;
  }
}
</style>
